import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

export const root = css`
  display: flex;
  flex-direction: column;
`;

export const toggleAllContainer = css`
  display: flex;
  flex-direction: row;
  align-items: start;
`;

export const checkboxes = (theme: Theme) => css`
  padding-left: ${theme.spacing[32]};
`;

export const hidden = css`
  display: none;
`;
